import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

interface FAQItem {
  question: string;
  reponse: string;
}

interface ExcursionFAQProps {
  faq: FAQItem[];
}

export const ExcursionFAQ = ({ faq }: ExcursionFAQProps) => {
  if (!faq || faq.length === 0) return null;

  return (
    <section>
      <div className="w-10 h-1 bg-primary mb-4" />
      <h2 className="text-3xl font-playfair font-bold mb-6">
        Questions fréquentes
      </h2>
      <Accordion type="single" collapsible className="space-y-4">
        {faq.map((item, index) => (
          <AccordionItem 
            key={index} 
            value={`item-${index}`}
            className="bg-card border rounded-lg px-6 shadow-card hover:shadow-float transition-shadow"
          >
            <AccordionTrigger className="text-left font-poppins font-semibold hover:no-underline py-4">
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground pb-4 leading-relaxed">
              {item.reponse}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
